<template>
    <section v-if="getSchoolsDistrict?.length">
        <h2 class="f4 text-bold">Schools in {{ getGeoDisplayText }}</h2>
        <div class="school-section">
            <div class="district-types m-b-4">
                <button
                    tracked="tracked"
                    v-for="tab in schoolType"
                    :key="tab.type"
                    :class="{ active: isActiveTab(tab.type) }"
                    v-on:click="switchSchoolType(tab.type);"
                    >
                    {{ tab.text }}
                </button>
            </div>
            <template v-if="isPublic">
                <p>Select a district to view it's schools.</p>
                <div ref="districtList" class="school-district-list cursor district-select-box m-t-3">
                    <div class="flex left middle inline bg-default corner outline" @click="toggleMenu" :class="{'selected':openMenu}">
                        <div v-if="selectedSchoolDistrict">
                            <b>{{selectedSchoolDistrict?.name}}</b>
                        </div>
                        <button type="button" class="self-right"><i class="f3" :class="openMenu ? 'icon-angle-up': 'icon-angle-down'"></i></button>
                        <div v-show="openMenu" ref="listItems" class="corner inline bg-default districts-list">
                            <div v-for="schoolDistrict in getSchoolsDistrict" class="radio-selection" :class="schoolDistrict.ncesId==selectedSchoolDistrict.ncesId ? 'active': ''" v-bind:key="schoolDistrict.ncesId" @click.stop="changeSchoolDistrict(schoolDistrict.ncesId)">
                                <div class="singleline">
                                    <input
                                        name="claimedHome"
                                        type="radio"
                                        :id="schoolDistrict.ncesId"
                                        :value="schoolDistrict.ncesId"
                                        />
                                    <i></i>
                                    <label :for="schoolDistrict.ncesId">{{schoolDistrict.name}}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div class="m-y-3" v-show="visibleSchools?.length">
                <p>{{ schoolDistrictDescription }}</p>
            </div>
            <div class="outline school-types m-y-2">
                <ul class="tab tab-bookmark center medium">
                    <li>
                        <button type="button" @click="switchSchoolCategory(0)" class="text-bold" :class="selectedSchoolType === 'elementarySchool' ? 'active': ''">
                            Elementary<span class="hidden-xs m-l-1"> schools</span>
                            <span class="count-pill m-l-1">{{ schoolsCount.elementarySchool }}</span>
                        </button>
                    </li>
                   <li>
                        <button type="button" @click="switchSchoolCategory(1)" class="text-bold" :class="selectedSchoolType === 'middleSchool' ? 'active': ''">
                            Middle<span class="hidden-xs m-l-1"> schools</span>
                            <span class="count-pill m-l-1">{{ schoolsCount.middleSchool }}</span>
                        </button>
                    </li>
                   <li>
                        <button type="button" @click="switchSchoolCategory(2)" class="text-bold" :class="selectedSchoolType === 'highSchool' ? 'active': ''">
                            High<span class="hidden-xs m-l-1"> schools</span>
                            <span class="count-pill m-l-1">{{ schoolsCount.highSchool }}</span>
                        </button>
                    </li>
                </ul>
                <div v-if="loadingSchools" class="f4 p-y-3 text-center">
                    Fetching schools of
                    <template v-if="isPublic && selectedSchoolDistrict">{{ selectedSchoolDistrict.name }}</template>
                    <template v-else>{{ msp.geo.formatAddress }}</template>
                </div>
                <div v-else-if="!visibleSchools?.length" class="f4 p-y-3 text-center">
                    <img class="no-school-image" loading="lazy" :src="glb.cdnUrl + 'images/no-schools.webp'" alt="No schools"/>
                </div>
                <div v-else class="grid gap-3 lg-grid-cols-2 sm-grid-cols-2 xs-grid-cols-1 p-x-3 p-y-3">
                    <div  class="school-panel outline flex middle left" v-for="(school , index) in visibleSchools" :key="index">
                        <div v-if="isPublic" class="school-rating outline f3 text-bold text-center">{{ school.rating ?? 'N/A'}}</div>
                        <div class="school-info">
                            <a class="link f5 text-bold" :href="glb.appUrl + school.dspUrl" >{{school.name}}</a>
                            <div class="f6" v-if="school.level">Grades {{ school.level }}</div>
                            <a class="f6 text-bold school-msp-url" :href="glb.appUrl + mspSchoolUrl(school)">See zoned homes <i class="icon-angle-right"></i></a>
                        </div>
                    </div>
                    <button v-if="schoolsCount[selectedSchoolType] > 6" type="button" class="text-brand text-bold flex middle left" @click="toggleSchools">{{ showAllSchools ? 'Show less' : 'Show all'}}
                        <i :class="showAllSchools ? 'icon-angle-up' : 'icon-angle-down'"></i>
                    </button>
                </div>
            </div>
            <div class="f7 text-gray m-t-2">
                Data provided by GreatSchools.
            </div>
       </div>
    </section>
</template>

<script src="./search-school.js"></script>

<style lang="scss">
    @use "./search-school.scss" as *;
</style>